<template>
  <div class="c-card-list u-bg-color-brand-two-lighten-100">
  <div class="grid-container">
    <div class="c-card-list__intro">
      <div class="filter-holder" :class="[isSearchOpen ? 'filter-holder--stack-mob' : '']">
        <div class="c-list-filter" v-if="categoryTags && categoryTags.length || topicTags && topicTags.length">
          <div class="c-list-filter__button">
              <filter-button name="Filter" @clicked="toggleMobileFilter" />
          </div>
          <div class="c-list-filter__options" :class="[isMobileFilterOpen ? 'c-list-filter__options--active' : '']">
            <div class="c-list-filter__item" v-if="categoryTags && categoryTags.length">
              <filter-dropdown v-model="selectedCategoryTag" :label="categoryTagsTitle"  :options="categoryTags" @changed="getData" />
            </div>
            <div class="c-list-filter__item" v-if="topicTags && topicTags.length">
              <filter-dropdown v-model="selectedTopicTag" :label="topicTagsTitle"  :options="topicTags" @changed="getData"  />
            </div>
          </div>
        </div>
        <filter-search v-if="textSearch == 'true'" @toggleSearchOpen="toggleSearchOpen" v-model="searchTerm" label="Search" @changed="getData"  />
      </div>
    </div>
    <transition name="fade" appear mode="out-in">
      <div v-if="hasResultsLoaded" key="results">
        <div class="c-card-list__grid" v-if="results.length">
          <card v-for="item in results" :item="item" :key="item.id" />
        </div>
        <div class="c-card-list__message" v-else>
          Sorry, no results found.
        </div>
      </div>
      <div class="c-card-list__message" v-else-if="hasError" key="error">
        Sorry, something went wrong.
      </div>
      <div class="c-card-list__message" v-else key="loading">
        <div class="lds-facebook"><div></div><div></div><div></div></div>
      </div>
    </transition>
  </div>
</div>

</template>

<script>
  import "url-search-params-polyfill";
  import Card from './Card.vue'
  import FilterDropdown from '../_filter/filter-dropdown/FilterDropdown.vue'
  import FilterButton from '../_filter/filter-button/FilterButton.vue'
  import FilterSearch from '../_filter/filter-search/FilterSearch.vue'
  import axios from "axios";
  import endpoints from "Globals/mando.endpoints";

  export default {
    name: "CardList",
    components: {
      Card,
      FilterDropdown,
      FilterButton,
      FilterSearch
    },
    props: {
      topicTags: {
        required: true,
        type: Array
      },
      categoryTags: {
        required: true,
        type: Array
      },
      componentId: {
        required: true,
        type: String
      },
      siteId: {
        required: true,
        type: String
      },
      textSearch: {
        required: true,
        type: String
      },
      categoryTagsTitle: {
        required: true,
        type: String
      },
      topicTagsTitle: {
        required: true,
        type: String
      }
    },
    data() {
      return {
        results: [],
        selectedCategoryTag: '',
        selectedTopicTag: '',
        searchTerm: '',
        hasResultsLoaded: false,
        hasError: false,
        isMobileFilterOpen: false,
        isSearchOpen: false,
      }
    },
    computed: {
      apiParams() {
        const params = {}
        params.componentId = this.componentId
        params.siteId = this.siteId
        if(this.selectedCategoryTag) {
          params.category = this.selectedCategoryTag
        }
        if(this.selectedTopicTag) {
          params.topic = this.selectedTopicTag
        }
        if(this.searchTerm) {
          params.searchTerm = this.searchTerm
        }
        return params
      }
    },
    methods: {
      getResultsFail(response) {
        this.hasError = true
        console.log('Error', response)
      },
      getResultsSuccess(response) {
        this.results = response.data.results
        this.hasResultsLoaded = true
      },
      getData() {
        this.hasResultsLoaded = false
        axios
        .get(endpoints('getCardList'), { params: this.apiParams })
        .then(this.getResultsSuccess.bind(this))
        .catch(this.getResultsFail.bind(this))
      },
      toggleMobileFilter(payLoad) {
        this.isMobileFilterOpen = payLoad
      },
      toggleSearchOpen(payLoad) {
        this.isSearchOpen = payLoad
      }
    },
    mounted() {
      this.getData()
    }
  };
  

</script>


// WEBPACK FOOTER //
// src/components/components/consumer/card-list/CardList.vue